import React from "react";
import { TextInput } from "@mantine/core";

export const BarRegistrationInput = ({ form }) => {
  return (
    <div>
      <TextInput
        label={
          <div className="flex items-center">
            Bar Registration Number
            <div className="relative ml-1 group">
              <span className="cursor-help text-gray-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </span>
              <div className="absolute left-0 bottom-full mb-2 w-64 p-2 bg-gray-800 text-white text-xs rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-10">
                Socius is designed exclusively for legal professionals to ensure
                ethical compliance. <br />
                <a href="/responsible-ai" className="text-blue-300 underline">
                  Learn more in our Responsible AI Center
                </a>
              </div>
            </div>
          </div>
        }
        placeholder="Enter your bar registration number"
        {...form.getInputProps("bar_registration_number")}
        className="w-full"
        error={form.errors.bar_registration_number}
      />
    </div>
  );
};
